import { OptionTuple } from '~/components/Input/Select/Select';
import { useDisciplineListQuery, UseDisciplineListQueryParams } from '../queries';
import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef, useMemo } from 'react';
import { HasStyle } from '~/types/HasStyle';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> &
  HasStyle & {
    query?: UseDisciplineListQueryParams;
  };

function DisciplineSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data, isLoading } = useDisciplineListQuery(props.query);

  const options = useMemo<OptionTuple[]>(() => {
    return (data ?? []).map(d => [d.label, d.name]);
  }, [data]);

  return (
    <Input.Select
      placeholder={props.placeholder ?? 'Alla discipliner'}
      aria-label={props['aria-label'] ?? 'Disciplin'}
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      disabled={props.disabled || isLoading}
      options={options}
      ref={ref}
      {...props}
    />
  );
}

export const DisciplineSelect = forwardRef(DisciplineSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof DisciplineSelectElement>;
